import { createSlice } from "@reduxjs/toolkit";
import { fetchServiceRecord } from "./ServiceRecordThunk";

const initialState = {
  list: [],
  loading: false,
  accessType: "WRITE", // later could be dynamic
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null, // 👈 separate field
    toDate: null,
  },
};

const serviceRecordSlice = createSlice({
  name: "serviceRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServiceRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchServiceRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = serviceRecordSlice.actions;
export default serviceRecordSlice.reducer;
